import { App } from '@/App';
import { SidebarProvider } from '@/common/providers';
import { Toaster } from '@/components/ui/sonner.tsx';
import '@/i18n';
import '@/index.css';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { DialogContainer } from './components/dialog';
import { DialogProvider } from './providers';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <HelmetProvider context={{}}>
    <BrowserRouter>
      <SidebarProvider>
        <DialogProvider>
          <App />
          <Toaster position="top-right" />
          <DialogContainer />
        </DialogProvider>
      </SidebarProvider>
    </BrowserRouter>
  </HelmetProvider>,
);
